exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".follow-card-content-container{flex-shrink:0;display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;line-height:1.5em}.follow-card-follow-button{margin-top:.5em;margin-left:auto;width:10em}", ""]);

// exports
